'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextAreaRedux = function (_Component) {
  _inherits(TextAreaRedux, _Component);

  function TextAreaRedux(props) {
    _classCallCheck(this, TextAreaRedux);

    var _this = _possibleConstructorReturn(this, (TextAreaRedux.__proto__ || Object.getPrototypeOf(TextAreaRedux)).call(this, props));

    _this.state = { textareaVal: '' };
    return _this;
  }

  _createClass(TextAreaRedux, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _index.TextAreaStyled,
        {
          isValid: this.props.isValid,
          isInvalid: this.props.isInvalid,
          textSize: this.props.textSize
        },
        _react2.default.createElement(
          _index.Button,
          {
            buttonLink: true,
            success: true,
            inline: true,
            small: true,
            onClick: function onClick() {
              var textVal = _this2.textAreaRedux;
              var cursorStart = textVal.selectionStart;
              var cursorEnd = textVal.selectionEnd;
              var text = _this2.state.textareaVal;
              _this2.setState({
                textareaVal: text.substr(0, cursorStart) + '***' + text.substr(cursorStart, cursorEnd - cursorStart) + '***' + text.substr(cursorEnd)
              });
            }
          },
          'Bold'
        ),
        _react2.default.createElement(
          'label',
          { htmlFor: this.props.input.name },
          this.props.label
        ),
        _react2.default.createElement('textarea', _extends({}, this.props.input, {
          ref: function ref(c) {
            _this2.textAreaRedux = c;
          },
          value: this.state.textareaVal,
          onChange: function onChange(event) {
            _this2.setState({
              textareaVal: event.target.value
            });
          }
        }))
      );
    }
  }]);

  return TextAreaRedux;
}(_react.Component);

exports.default = TextAreaRedux;


TextAreaRedux.defaultProps = {
  name: '',
  label: '',
  input: {},
  isValid: false,
  isInvalid: false,
  textSize: '16px'
};

TextAreaRedux.propTypes = {
  name: _propTypes2.default.string,
  label: _propTypes2.default.string,
  input: _propTypes2.default.object,
  isValid: _propTypes2.default.bool,
  isInvalid: _propTypes2.default.bool,
  textSize: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/TextAreaRedux.js
// module id = 111
// module chunks = 0